import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme/constants';

const Navigator = props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
  appearance: "subtle",
  spacing: "none",
  theme: (currentTheme, themeProps) => {
    const {
      buttonStyles,
      ...rest
    } = currentTheme(themeProps);
    const halfGridSize = gridSize() / 2;
    return {
      buttonStyles: { ...buttonStyles,
        paddingLeft: `${halfGridSize}px`,
        paddingRight: `${halfGridSize}px`,
        'html[dir=rtl] &': {
          transform: 'rotate(180deg)'
        }
      },
      ...rest
    };
  }
}));

export default Navigator;